export default "__VITE_ASSET__66105b51__"